import { render, staticRenderFns } from "./FormMe.vue?vue&type=template&id=24df50c6&"
import script from "./FormMe.vue?vue&type=script&lang=js&"
export * from "./FormMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports